module.exports = __webpack_public_path__ + "ac3f799d5bbaf5196fab15ab8de8431c.ttf";